export default "__VITE_ASSET__e2e23e60__"